module.exports = __webpack_public_path__ + "media/images/instagram-5b23a837268b09d0efa9e307023c1dae.svg";